import {
  type ReferentialEnum,
  referentialEnumToReferentialCodeList,
} from "@pharmupp/p3-front-commons"

export const lgoConf = {
  NOT_DISCLOSED: { label: "Non communiqué" },
  CADUCIEL: { label: "Caduciel" },
  SMART_RX: { label: "Smart RX" },
  LGPI: { label: "LGPI" },
  WINPHARMA: { label: "WinPharma" },
  LEO: { label: "LEO" },
  PHARMALAND: { label: "Pharmaland" },
  PHARMAVIALE: { label: "Pharmavitale" },
  VINDILIS: { label: "Vindilis" },
  CRYSTAL: { label: "Crystal" },
  AUTRES: { label: "Autres" },
} satisfies ReferentialEnum

export const lgoReferential = referentialEnumToReferentialCodeList(lgoConf)
